(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{
document.querySelectorAll('.idoo-knife-gallery').forEach(gallery=>{
const track=gallery.querySelector('.idoo-knife-track');
const dots=[...gallery.querySelectorAll('.idoo-knife-dots button')];
dots.forEach((button,index)=>button.addEventListener('click',()=>track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)))},{passive:true});
});
});

  } catch(e) { console.error(e); }
})();
})();
